import { Stack } from '@cardboard-ui/react';
import React from 'react';
import { PropsWithChildren } from 'react';
import { useDesktopMenu } from './DesktopMenuContext';

export const MenuItemStack = (
  props: PropsWithChildren<{ 'aria-label'?: string }>,
) => {
  const { isCollapsed } = useDesktopMenu();

  return (
    <Stack
      align={isCollapsed ? 'center' : 'start'}
      spacing="1"
      w="100%"
      {...props}
    />
  );
};
